module.exports = __webpack_public_path__ + "static/av_logo-f35033fb8b9c01c1eb22caa002606329.png";